import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, renderSlot as _renderSlot, normalizeClass as _normalizeClass, toHandlers as _toHandlers, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../images/btn-arrow-left.png'
import _imports_1 from '../../images/btn-arrow-right.png'


const _withScopeId = n => (_pushScopeId("data-v-21e60713"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "carousel-inner" }

import { ref, computed, watch, onMounted, nextTick } from 'vue';
  import _ from 'lodash';
  import { Carousel } from 'bootstrap';

  export interface IProps {
    items: any[]
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    items: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { items: any[] }

  

  const root = ref();
  const current = ref(0);
  const renderRoot = ref(true);
  const chunkSize = 5;
  let carousel: Carousel;

  const stepChunked = computed(() => {
    return _.chunk(props.items, chunkSize);
  });

  const on = {
    'slide.bs.carousel'(e: Carousel.Event) {
      current.value = e.to;
    }
  };

  const initCarousel = async () => {
    if (carousel) {
      carousel.dispose();
      // 重新渲染节点
      renderRoot.value = false;
      await nextTick();
      renderRoot.value = true;
      await nextTick();
    }
    current.value = 0;
    carousel = new Carousel(root.value, {
      interval: false
    });
  };

  const handleSlideNext = () => {
    carousel.next();
  };

  const handleSlidePrev = () => {
    carousel.prev();
  };

  watch(
    () => props.items.length,
    initCarousel
  );

  onMounted(() => {
    initCarousel();
  });


return (_ctx: any,_cache: any) => {
  return (renderRoot.value)
    ? (_openBlock(), _createElementBlock("div", _mergeProps({
        key: 0,
        ref_key: "root",
        ref: root,
        class: "carousel slide"
      }, _toHandlers(on)), [
        (__props.items.length > chunkSize)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("img", {
                src: _imports_0,
                class: "btn-arrow btn-left",
                onClick: handleSlidePrev
              }),
              _createElementVNode("img", {
                src: _imports_1,
                class: "btn-arrow btn-right",
                onClick: handleSlideNext
              })
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stepChunked), (group, groupIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: groupIndex,
              class: _normalizeClass(["carousel-item", { active: groupIndex === 0 }])
            }, [
              _renderSlot(_ctx.$slots, "default", {
                group: group,
                groupIndex: groupIndex
              })
            ], 2))
          }), 128))
        ])
      ], 16))
    : _createCommentVNode("", true)
}
}

})